import { useCallback, useEffect, useState } from "react";
import axiosInstance from "../axiosInstance";

const BASE = "/system/sequence-types";

const normalizeOptions = (options) => {
  if (!Array.isArray(options)) return [];
  return options
    .map((option) => ({
      value: option?.value ? String(option.value) : "",
      label: option?.label ? String(option.label) : "",
    }))
    .filter((option) => option.value && option.label);
};

export const getSequenceTypes = () => axiosInstance.get(BASE).then((res) => res.data);

export const useGetSequenceTypes = (enabled = true) => {
  const [sequenceTypes, setSequenceTypes] = useState([]);
  const [resetTypes, setResetTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axiosInstance.get(BASE);
      const payload = response?.data;
      const data = payload?.data || {};
      setSequenceTypes(normalizeOptions(data.sequenceTypes));
      setResetTypes(normalizeOptions(data.resetTypes));
    } catch (err) {
      const msg =
        err.response?.data?.message ||
        "Failed to load sequence type options";
      setError(msg);
      setSequenceTypes([]);
      setResetTypes([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!enabled) return;
    fetchData();
  }, [enabled, fetchData]);

  return {
    sequenceTypes,
    resetTypes,
    loading,
    error,
    refetch: fetchData,
  };
};
